var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackspike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 54,
    viewBox: "0 0 92 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8113 0.558594L50.264 14.0437L63.2742 2.57348L58.4876 16.0192L78.0776 8.30745L64.7825 19.6687L87.9684 16.8933L68.1892 24.4381L91.4427 27.0188L68.1892 29.5994L87.9684 37.1442L64.7825 34.3688L78.0776 45.7278L58.4876 38.0183L63.2742 51.4641L50.264 39.9938L45.8113 53.4789L41.3609 39.9938L28.3507 51.4641L33.1373 38.0183L13.5472 45.7278L26.8423 34.3688L3.6565 37.1442L23.4357 29.5994L0.182129 27.0188L23.4357 24.4381L3.6565 16.8933L26.8423 19.6687L13.5472 8.30745L33.1373 16.0192L28.3507 2.57348L41.3609 14.0437L45.8113 0.558594Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackspike);
export default __webpack_public_path__ + "static/media/blackspike.65074b9dabb62d21966ea2468689581c.svg";
export { ForwardRef as ReactComponent };